import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
	title: {
	  marginLeft: theme.spacing(1),  
	  marginTop: theme.spacing(1),  
	},
  }));
  

export default function Title(props) {
	const classes = useStyles();

	return (
		<Typography variant="h5" color="primary" gutterBottom className={classes.title}>
			{props.children}
		</Typography>
	);
}
